'use strict';
(function(angular) {
  angular.module('fetchtv.controllers')
    .controller('modalConfirmController', [
      '$scope',
      '$uibModalInstance',
      'options',
      function(
        $scope,
        $uibModalInstance, options) {
        $scope.options = options;

        $scope.closeModal = function() {
          $uibModalInstance.dismiss('cancelled');
        };

        $scope.acceptModal = function() {
          if(!$scope.options.returnClose) {
            $uibModalInstance.close('accept');
          } else {
            $uibModalInstance.close($scope.options.returnClose);
          }
        };
      }]);
})(angular);

